import indexMutations from "./indexStore/mutations";
import retrieveProjectSritMutations from "./retrieveProjectSrit/mutations"
import governmentMutations from "./government/mutations";
// 公有内容直接写入。
var mutations = {
    ...indexMutations,
    ...retrieveProjectSritMutations,
    ...governmentMutations
};
export default mutations;